"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoCertifierClient = exports.SERVICE_ID = void 0;
const eventemitter3_1 = require("eventemitter3");
const utils_1 = require("@streamr/utils");
const RestClient_1 = require("./RestClient");
const fs_1 = __importDefault(require("fs"));
const path_1 = __importDefault(require("path"));
const forge = __importStar(require("node-forge"));
const logger = new utils_1.Logger(module);
const ensureConfigFileWritable = (directory) => {
    const baseDirectory = getBaseDirectory(directory);
    fs_1.default.accessSync(baseDirectory, fs_1.default.constants.W_OK | fs_1.default.constants.R_OK);
    logger.trace(`Directory ${baseDirectory} is readable and writable`);
};
const getBaseDirectory = (directory) => {
    const subDirs = directory.split(path_1.default.sep);
    do {
        const current = subDirs.join(path_1.default.sep);
        if (fs_1.default.existsSync(current)) {
            return current;
        }
        subDirs.pop();
    } while (subDirs.length > 0);
    return path_1.default.sep;
};
exports.SERVICE_ID = 'system/auto-certificer';
const ONE_DAY = 1000 * 60 * 60 * 24;
const MAX_INT_32 = 2147483647;
// TODO: remove code duplication regarding ongoingSessions management
// TODO: add logging and make logging consistent
// TODO: validate CertifiedSubdomain when read from file and when received from server
class AutoCertifierClient extends eventemitter3_1.EventEmitter {
    updateTimeout;
    restClient;
    configFile;
    streamrWebSocketPort;
    ongoingSessions = new Set();
    constructor(configFile, streamrWebSocketPort, restApiUrl, registerRpcMethod) {
        super();
        this.restClient = new RestClient_1.RestClient(restApiUrl);
        this.configFile = (0, utils_1.filePathToNodeFormat)(configFile);
        this.streamrWebSocketPort = streamrWebSocketPort;
        registerRpcMethod(exports.SERVICE_ID, 'hasSession', this.hasSession.bind(this));
    }
    async start() {
        if (!fs_1.default.existsSync(this.configFile)) {
            await this.createCertificate();
        }
        else {
            await this.ensureCertificateValidity();
        }
    }
    async ensureCertificateValidity() {
        const certificate = this.loadCertificateFromDisk();
        const certObj = forge.pki.certificateFromPem(certificate.certificate);
        const expirationTimestamp = certObj.validity.notAfter.getTime();
        if (Date.now() >= expirationTimestamp - ONE_DAY) {
            await this.updateCertificate();
        }
        else {
            // TODO: most of the time the ip should not change. Calling this is important for whenever it does.
            // should avoid calling this.updateSubDomainIp in scheduled calls if certificate is not expiring.
            await this.updateSubdomainIp();
            this.scheduleCertificateUpdate(expirationTimestamp);
            this.emit('updatedCertificate', certificate);
        }
    }
    loadCertificateFromDisk() {
        const certificate = JSON.parse(fs_1.default.readFileSync(this.configFile, 'utf8'));
        return certificate;
    }
    stop() {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
            this.updateTimeout = undefined;
        }
    }
    scheduleCertificateUpdate(expirationTimestamp) {
        if (this.updateTimeout) {
            clearTimeout(this.updateTimeout);
            this.updateTimeout = undefined;
        }
        // update certificate 1 day before it expires
        let updateIn = expirationTimestamp - Date.now();
        if (updateIn > ONE_DAY) {
            updateIn = updateIn - ONE_DAY;
        }
        // TODO: This sets the timeout to the maximum value of a 32-bit integer due to the limitation setTimeout has.
        // The original expirationTimestamp should be kept somewhere so that the certificate is not updated every 24 days.
        if (updateIn > MAX_INT_32) {
            updateIn = MAX_INT_32;
        }
        logger.info(updateIn + ' milliseconds until certificate update');
        // TODO: use tooling from @streamr/utils to set the timeout with an abortController.
        this.updateTimeout = setTimeout(() => this.ensureCertificateValidity(), updateIn);
    }
    createCertificate = async () => {
        const dir = path_1.default.dirname(this.configFile);
        ensureConfigFileWritable(dir);
        const sessionId = await this.restClient.createSession();
        let certifiedSubdomain;
        this.ongoingSessions.add(sessionId);
        try {
            certifiedSubdomain = await this.restClient.createSubdomainAndCertificate(this.streamrWebSocketPort, sessionId);
        }
        finally {
            this.ongoingSessions.delete(sessionId);
        }
        // TODO: use async fs methods?
        if (!fs_1.default.existsSync(dir)) {
            fs_1.default.mkdirSync(dir, { recursive: true });
        }
        fs_1.default.writeFileSync(this.configFile, JSON.stringify(certifiedSubdomain));
        const certObj = forge.pki.certificateFromPem(certifiedSubdomain.certificate);
        const expirationTimestamp = certObj.validity.notAfter.getTime();
        this.scheduleCertificateUpdate(expirationTimestamp);
        this.emit('updatedCertificate', certifiedSubdomain);
    };
    updateCertificate = async () => {
        const sessionId = await this.restClient.createSession();
        this.ongoingSessions.add(sessionId);
        const oldCertifiedSubdomain = JSON.parse(fs_1.default.readFileSync(this.configFile, 'utf8'));
        const updatedCertifiedSubdomain = await this.restClient.updateCertificate(oldCertifiedSubdomain.fqdn.split('.')[0], this.streamrWebSocketPort, sessionId, oldCertifiedSubdomain.authenticationToken);
        this.ongoingSessions.delete(sessionId);
        // TODO: use async fs methods?
        fs_1.default.writeFileSync(this.configFile, JSON.stringify(updatedCertifiedSubdomain));
        const certObj = forge.pki.certificateFromPem(updatedCertifiedSubdomain.certificate);
        const expirationTimestamp = certObj.validity.notAfter.getTime();
        this.scheduleCertificateUpdate(expirationTimestamp);
        // TODO: if the certificate was not updated there's no need to emit the event. Could compare certificates?
        this.emit('updatedCertificate', updatedCertifiedSubdomain);
    };
    // This method should be called whenever the IP address or port of the node changes
    updateSubdomainIp = async () => {
        if (!fs_1.default.existsSync(this.configFile)) {
            logger.warn('updateSubdomainIp() called while subdomain file does not exist');
            return;
        }
        // TODO: use async fs methods?
        const oldSubdomain = JSON.parse(fs_1.default.readFileSync(this.configFile, 'utf8'));
        logger.info('updateSubdomainIp() called for ' + oldSubdomain.fqdn);
        const sessionId = await this.restClient.createSession();
        this.ongoingSessions.add(sessionId);
        await this.restClient.updateSubdomainIp(oldSubdomain.fqdn.split('.')[0], this.streamrWebSocketPort, sessionId, oldSubdomain.authenticationToken);
        this.ongoingSessions.delete(sessionId);
    };
    // IAutoCertifierRpc implementation
    // TODO: could move to the DHT package or move all rpc related logic here from AutoCertifierClientFacade in DHT 
    async hasSession(request) {
        logger.info('hasSession() called ' + this.ongoingSessions.size + ' ongoing sessions');
        if (this.ongoingSessions.has(request.sessionId)) {
            return { sessionId: request.sessionId };
        }
        else {
            throw new Error(`Session not found ${request.sessionId}`);
        }
    }
}
exports.AutoCertifierClient = AutoCertifierClient;
//# sourceMappingURL=AutoCertifierClient.js.map